import { z } from 'zod';
import { customerBrandIdsSchema } from './customer-brand-ids.js';
/** New Customer's brands, a form of their own beside the customer fields the edit form shares; validated as `createCustomer`'s `brandIds` are. */
export const customerBrandsFormSchema = z.object({
    brandIds: customerBrandIdsSchema,
});
//# sourceMappingURL=brands-form.js.map